import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { ItemSubgrupo } from './item-subgrupo';

@Injectable({
    providedIn: 'root'
})
export class ItemSubgrupoCrudHttpService implements Crud<ItemSubgrupo> {
    resource = 'itemsubgrupo';

    constructor(private crudService: CrudService) { }

    search(): Observable<ItemSubgrupo[]> {
        return this.crudService.search<ItemSubgrupo>(this.resource);
    }

    find(id: number): Observable<ItemSubgrupo> {
        return this.crudService.find<ItemSubgrupo>(this.resource, id);
    }

    load(id: number): Observable<ItemSubgrupo> {
        return this.crudService.load<ItemSubgrupo>(this.resource, id);
    }

    insert(entity: ItemSubgrupo): Observable<ItemSubgrupo> {
        return this.crudService.insert<ItemSubgrupo>(this.resource, entity);
    }

    update(entity: ItemSubgrupo): Observable<ItemSubgrupo> {
        return this.crudService.update<ItemSubgrupo>(this.resource, entity);
    }

    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
